<template>
  <div class="small-hl-upload">
    <div class="upload-image" v-if="imgUrl" :style="{ width: width + 'px', height: height + 'px' }">
      <img :src="imgUrl" alt="" class="upload-image__img" :style="imgStyle" />
      <div class="upload-image-mask">
        <!--        <el-tooltip effect="dark" content="查看大图" placement="top">-->
        <!--          <span class="samll-upload-image-icon" @click="handlePreview">-->
        <!--            <svg class="icon" aria-hidden="true">-->
        <!--              <use xlink:href="#icon-eyes"></use>-->
        <!--            </svg>-->
        <!--          </span>-->
        <!--        </el-tooltip>-->
        <el-tooltip effect="dark" :content="$t('Common.del')" placement="top">
          <span class="samll-upload-image-icon" @click="handleDelete">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-del_24"></use>
            </svg>
          </span>
        </el-tooltip>
      </div>
    </div>
    <div class="upload-add" v-else :style="{ width: width + 'px', height: height + 'px' }">
      <input
        ref="samllUpload"
        type="file"
        @change="handleChange"
        accept=".jpeg,.jpg,.png"
        class="upload-add__input"
        :style="{ width: width + 'px', height: height + 'px' }"
      />
      <hl-button
        type="text"
        class="upload-add__button"
        @click="$refs.samllUpload.click()"
        :style="{ top: top + 'px' }"
      >
        <span class="samll-upload-image-icon">
          <svg class="icon" aria-hidden="true" style="color: #A1A5AD">
            <use xlink:href="#icon-add"></use>
          </svg>
        </span>
      </hl-button>
    </div>
    <div class="upload-tip form-item-tip" v-if="showTip">
      <slot name="tip"></slot>
    </div>
    <div class="upload-preview" v-if="visible">
      <div class="upload-preview-mask"></div>
      <div class="upload-preview-wrap">
        <img :src="imgUrl" alt="" class="upload-preview__img" />
        <div class="close" @click="visible = false">
          <svg class="icon close-icon" aria-hidden="true">
            <use xlink:href="#icon-close"></use>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createImgUrl } from '@/utils/utils'
export default {
  name: 'SmallUploadButton',
  props: {
    img: String,
    width: {
      type: Number,
      default: 32
    },
    height: {
      type: Number,
      default: 32
    },
    top: {
      type: Number,
      default: 0
    },
    needTransform: {
      type: Boolean,
      default: true
    },
    showTip: {
      type: Boolean,
      default: true
    },
    limit: {
      type: Number,
      default: 1
    },
    accept: {
      type: String,
      default: 'image/jpeg,image/jpg,image/png,image/gif'
    },
    setSize: {
      type: Boolean,
      default: false
    },
    imgWidth: {
      type: Number,
      default: 0
    },
    imgHeight: {
      type: Number,
      default: 0
    },
    imgStyle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      imgUrl: this.img && this.needTransform ? createImgUrl(this.img) : '',
      visible: false
    }
  },
  watch: {
    img(val) {
      this.imgUrl = val && this.needTransform ? createImgUrl(val) : val
    }
  },
  methods: {
    handleChange(e) {
      let file = e.target.files[0]
      if (!this.accept.includes(file.type)) {
        return this.$message.warning(`${this.$t('Common.imgUploadTips1')}`)
      }
      if (file.size > this.limit * 1024 * 1024) {
        this.$refs.samllUpload.value = null
        return this.$message.warning(`${this.$t('Common.imgUploadTips2')}: ${this.limit} MB`)
      }
      if (this.setSize) {
        console.log('handleChange4', file)
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
          // 让页面中的img标签的src指向读取的路径
          let img = new Image()
          img.src = reader.result
          img.onload = () => {
            const conSize = img.width === this.imgWidth && img.height === this.imgHeight
            if (!conSize) {
              this.$refs.samllUpload.value = null
              return this.$message.warning(
                `${this.$t('Common.imgUploadTips2')}: ${this.imgWidth}×${this.imgHeight} px`
              )
            } else {
              if (file && this.imgUrl) {
                URL.revokeObjectURL(this.imgUrl)
              }
              this.imgUrl = URL.createObjectURL(file)
              this.$emit('pickImg', file)
            }
          }
        }
      } else {
        if (file && this.imgUrl) {
          URL.revokeObjectURL(this.imgUrl)
        }
        this.imgUrl = URL.createObjectURL(file)
        this.$emit('pickImg', file)
      }
    },
    handlePreview() {
      this.visible = true
    },
    handleDelete() {
      URL.revokeObjectURL(this.imgUrl)
      this.imgUrl = ''
      this.$nextTick(() => {
        this.$refs.samllUpload.value = null
      })
      this.$emit('pickImg', '')
    }
  }
}
</script>
<style lang="scss">
.small-hl-upload {
  .upload-add {
    position: relative;
    width: 32px;
    height: 32px;
    border-radius: 4px;
    border: 2.5px dashed rgba(218, 223, 230, 1);
    text-align: center;
    line-height: 32px;
    cursor: pointer;
    &:hover {
      background: #eff4fc;
    }
    &:active {
      background: #e3e8f0;
    }
  }
  .upload-add__input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    z-index: 0;
    cursor: pointer;
  }
  .upload-add__button {
    position: relative;
    z-index: 1;
  }
  .upload-image {
    position: relative;
    width: 32px;
    height: 32px;
    &:hover {
      .upload-image-mask {
        z-index: 1;
      }
    }
  }
  .upload-image__img {
    width: 100%;
    height: 100%;
    display: block;
    border-radius: 4px;
  }
  .upload-image-mask {
    z-index: -1;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    .samll-upload-image-icon {
      color: #ffffff;
      font-size: 16px;
      padding: 0 2px;
      background: transparent;
      border-radius: 4px;
      cursor: pointer;
      &:hover {
        background: rgba(255, 255, 255, 0.35);
      }
      &:active {
        background: rgba(255, 255, 255, 0.45);
      }
      & + .samll-upload-image-icon {
        margin-left: 4px;
      }
    }
  }
  .upload-preview {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
  }
  .upload-preview-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
  }
  .upload-preview-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 40%;
    .close {
      position: absolute;
      right: -48px;
      top: -40px;
      width: 40px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.3);
      color: #ffffff;
      font-size: 20px;
      cursor: pointer;
      &:hover {
        background: rgba(0, 0, 0, 0.38);
      }
      &:active {
        background: rgba(0, 0, 0, 0.46);
      }
    }
    .close-icon {
    }
  }
  .upload-preview__img {
    display: block;
    width: 100%;
  }
}
</style>
